import { render, staticRenderFns } from "./ReputationProvider.vue?vue&type=template&id=7bfd8887&scoped=true"
import script from "./ReputationProvider.vue?vue&type=script&lang=js"
export * from "./ReputationProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd8887",
  null
  
)

export default component.exports